import { joinPhone } from "./organisationContactsRules";

export const organisationContactsUrl = (domain, id) =>
  `${domain}monitoring/organisation/contacts/${id == null ? "" : `${encodeURIComponent(id)}/`}`;

export const mapOrganisationContact = (row) => ({
  id: row.id,
  name: row.name ?? "",
  designation: row.designation ?? "",
  phone: joinPhone(row.phone_country_code ?? "", row.phone_number ?? "").trim(),
  whatsapp: joinPhone(row.whatsapp_country_code ?? "", row.whatsapp_number ?? "").trim(),
  email: row.email_address ?? "",
  contactType: row.contact_type,
});

export const organisationContactPayload = (draft) => ({
  name: draft.name.trim(),
  designation: draft.designation.trim() || null,
  phone_country_code: draft.phoneCode,
  phone_number: draft.phone.trim(),
  whatsapp_country_code: draft.whatsapp.trim() ? draft.whatsappCode : null,
  whatsapp_number: draft.whatsapp.trim() || null,
  email_address: draft.email.trim(),
  contact_type: draft.contactType,
});
